<template>
    <div
        v-if="showAddDialog"
        class="dialog-mask">
        <div class="add-user-area">
            <div class="add-user-title">
                批量录入主控信息
            </div>
            <a-textarea
                v-model="info"
                :rows="12"/>
            <div
                class="message"
                v-if="showError">
                {{ showMessage }}
            </div>
            <div class="submit-button-area">
                <a-button
                    v-on:click="addConfirm"
                    class="submit-button"
                    size="large"
                    type="primary">
                    录入
                </a-button>
            </div>
            <a-icon
                v-on:click="addCancel"
                class="close-button"
                type="close" />
        </div>
    </div>
</template>
<script>
 import Vue from 'vue';

 import { isEmptyOrWhitespace } from "../util/utils.js"
 import message from "ant-design-vue/lib/message";

 import InputGroup from "ant-design-vue/lib/input/Group";
 import TextArea from "ant-design-vue/lib/input/TextArea";
 import Radio from "ant-design-vue/lib/radio/Radio";
 import RadioGroup from "ant-design-vue/lib/radio/Group";
 import RadioButton from "ant-design-vue/lib/radio/RadioButton";

 Vue.component(InputGroup.name, InputGroup);
 Vue.component(TextArea.name, TextArea);
 Vue.component(RadioGroup.name, RadioGroup);
 Vue.component(RadioButton.name, RadioButton);
 Vue.component(Radio.name, Radio);

 export default {
     name: 'AddDeviceDialog',
     data() {
         return {
             showAddDialog: false,
             showError: false,
             addUserError: false,
             showMessage: "",
             downloadNumber: 1,
             info: ""
         }
     },
     components: {
     },
     props: {
     },
     computed: {
     },
     methods: {
         show() {
             this.init()
             this.showAddDialog = true
         },
         init() {
             this.showError = false
             this.showMessage = ""
         },
         addCancel() {
             this.showAddDialog = false
         },
         addConfirm() {
             this.showAddDialog = false
             var deviceInfo = this.info.replace(/(\r\n|\n|\r)/gm, "\n").split("\n").filter((e) => {
                 return e != ""
             })

             var info = []
             for (var i = 0; i < deviceInfo.length; i += 2) {
                 info.push({
                     SerialNum: deviceInfo[i],
                     PasswordHash: deviceInfo[i + 1]
                 })
             }

             var url = process.env.VUE_APP_API_SERVER + '/box'
             var accessToken = localStorage.getItem('accessToken')

             var that = this
             fetch(url, {
                 method: "POST",
                 body: JSON.stringify(info),
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }).then(res => {
                 if (!res.ok) { throw res }
                 return res.json()
             }).catch(error => {
                 message.error("设备批量添加失败: " + error)
             }).then(response => {
                 message.success("设备批量添加成功")
             })
         },
     },
 }
</script>

<style scoped>
 .dialog-mask {
     position: absolute;
     top: 0;
     bottom: 0;
     left: 0;
     right: 0;
     background-color: rgba(0, 0, 0, 0.8);
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     z-index: 1000;
 }
 .add-user-area {
     padding: 30px;
     background-color: #FFF;
     border: 1px solid #DDD;
     border-radius: 5px;
     box-shadow: 0px -5px 10px -10px #858484;
     width: 650px;
     height: 500px;
     position: absolute;
     display: flex;
     flex-direction: column;
     align-items: center;
 }
 .add-user-title {
     font-size: 24px;
     margin-bottom: 40px;
 }
 .submit-button-area {
     position: absolute;
     bottom: 30px;
     display: flex;
     flex-direction: row;
     align-items: center;
 }
 .submit-button {
     width: 150px;
     margin-left: 10px;
     margin-right: 10px;
 }
 .input-line {
     width: 100%;
     display: flex;
     flex-direction: row;
     align-items: center;
     margin-top: 10px;
 }
 .input-label {
     width: 120px;
     font-size: 16px;
     margin-right: 10px;
     text-align: start;
 }

 .input-type-line {
     width: 100%;
     display: flex;
     flex-direction: row;
     align-items: center;
     margin-top: 12px;
 }

 .input-type-label {
     width: 88px;
     font-size: 16px;
     margin-right: 10px;
     text-align: start;
 }

 .close-button {
     position: absolute;
     top: 10px;
     right: 10px;
     cursor: pointer;
     color: #AAA;
 }
 .close-button:hover {
     color: #666;
 }
 .message {
     margin-top: 10px;
     color: #D80E3B;
     font-size: 14px;
 }

 /* 禁止 Chrome 自动填充修改 input 样式 */
 input:-webkit-autofill,
 input:-webkit-autofill:hover,
 input:-webkit-autofill:focus,
 input:-webkit-autofill:active {
     -webkit-transition-delay: 99999s;
     -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
 }

 .number-box {
     width: 200px;
 }

 textarea.input-area.ant-input {
     height: 400px;
     max-height: 400px;
 }
</style>
